import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, TrendingUp, MousePointer, Clock, MessageSquare, Star } from 'lucide-react';
import Button from '@/components/ui/Button';

const metrics = [
  {
    icon: <TrendingUp className="w-6 h-6 text-orcsys-500" />,
    title: "Taux de compréhension du concept"
  },
  {
    icon: <MousePointer className="w-6 h-6 text-orcsys-500" />,
    title: "Clics sur les fonctionnalités clés"
  },
  {
    icon: <Clock className="w-6 h-6 text-orcsys-500" />,
    title: "Temps moyen par étape"
  },
  {
    icon: <MessageSquare className="w-6 h-6 text-orcsys-500" />,
    title: "Feedback qualitatif synthétisé"
  },
  {
    icon: <Star className="w-6 h-6 text-orcsys-500" />,
    title: "Score d'intérêt global"
  }
];

const ResultsSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="container px-4 mx-auto">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orcsys-100 mb-6">
              <BarChart3 className="w-8 h-8 text-orcsys-500" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Suivez vos résultats en temps réel
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto mb-6">
              Parce qu'un prototype sans données, c'est juste une intuition.
            </p>
            <p className="text-lg text-slate-700 max-w-3xl mx-auto">
              Chaque prototype Orcsys peut être accompagné d'un mini-dashboard.
              Vous suivez en direct comment vos testeurs interagissent, ce qui les attire, les bloque ou les convainc.
              Les données ne restent pas abstraites — elles deviennent vos premiers arguments de preuve.
            </p>
          </motion.div>

          <div className="flex flex-wrap justify-center gap-6 mb-8">
            {metrics.map((metric, index) => (
              <motion.div
                key={index}
                className="bg-slate-50 rounded-xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-100 m-0"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                style={{ minWidth: "260px", flex: '1 1 260px', maxWidth: "340px" }}
              >
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 rounded-lg bg-orcsys-50 flex items-center justify-center flex-shrink-0">
                    {metric.icon}
                  </div>
                  <p className="text-sm font-medium text-slate-900">
                    {metric.title}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <Button.Link
              href="#contact"
              className="bg-orcsys-500 hover:bg-orcsys-600 text-white"
              size="lg"
            >
              Découvrez comment vos utilisateurs réagissent avant même la V1
            </Button.Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;

